// "Target Batch Size" in website_inputs is either a single number ("7") or a
// range ("5-7"). Normalize it for display and derive the per-year figure
// (4 cycles/year) so the FAQ and apply timeline never drift apart. A per-year
// range is rounded outward to the nearest 5 so it reads as an estimate
// (5-7 per cycle -> 20-30/year, not 20-28).
const FALLBACK = '5-7';

export function parseBatchSize(raw) {
  const text = String(raw || FALLBACK).trim();
  const match = text.match(/^(\d+)\s*[-–]\s*(\d+)$/) || text.match(/^(\d+)$/);
  if (!match) {
    return { label: text, perYear: null };
  }
  const min = Number(match[1]);
  const max = match[2] !== undefined ? Number(match[2]) : min;
  const label = min === max ? `${min}` : `${min}–${max}`;
  const perYear = min === max
    ? `${min * 4}`
    : `${Math.floor((min * 4) / 5) * 5}–${Math.ceil((max * 4) / 5) * 5}`;
  return { label, perYear };
}
